import React from "react"
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
  Spinner,
} from "@heroui/react"
import { useNavigate } from "react-router-dom"
import EditIcon from "../Icons/EditIcon"
import classes from "./ArticlesTable.module.scss"

interface Props {
  articles: KnowladgebaseArticleResponse[]
  pages: number
  page: number
  loading: boolean
  onPageChange(page: number): void
}

const ArticlesTable = (props: Props) => {
  const { articles, loading, pages, page, onPageChange } = props

  const navigate = useNavigate()

  const getValue = (value: any) => {
    if (loading) {
      return <Spinner size="sm" />
    }
    return value
  }

  return (
    <Table
      isCompact
      bottomContent={
        pages > 0 ? (
          <div className="flex w-full justify-center">
            <Pagination
              isCompact
              showControls
              showShadow
              color="primary"
              page={page}
              total={pages}
              onChange={(page) => onPageChange(page)}
            />
          </div>
        ) : null
      }
    >
      <TableHeader>
        <TableColumn>עריכה</TableColumn>
        <TableColumn>כותרת</TableColumn>
        <TableColumn>קישור</TableColumn>
        <TableColumn>קטגוריה</TableColumn>
        <TableColumn>נוצר</TableColumn>
        <TableColumn>עודכן לאחרונה</TableColumn>
      </TableHeader>
      <TableBody emptyContent={"No rows to display."}>
        {articles.map((article, index) => {
          return (
            <TableRow key={`${index}`} className={classes.tableRow}>
              <TableCell>
                <EditIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/article/edit/${article.id}`)}
                />
              </TableCell>
              <TableCell style={{ width: "100%" }}>
                {getValue(article.title)}
              </TableCell>
              <TableCell>
                <a href={`https://help.diodrive.co.il/article/${article.slug}`}>
                  {getValue(article.slug)}
                </a>
              </TableCell>
              <TableCell>{getValue(article.categoryName)}</TableCell>
              <TableCell>
                {getValue(
                  new Date(article.createdDate).toLocaleString("he-IL"),
                )}
              </TableCell>
              <TableCell>
                {getValue(
                  new Date(article.lastUpdated).toLocaleString("he-IL"),
                )}
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
export default ArticlesTable
